module.exports = __webpack_public_path__ + "img/1445785268.87f95e18.jpg";